import { useState, useEffect, useContext, useRef } from 'react';

import { cmnContext } from '../../../../../common/CmnContext';
import { SaleListContext } from '../../../SaleListContext';


export function SaleListDetailSeriesItem(props: any) {

  const available = props.available;
  const dispIndex = props.dispIndex;
  const setDispIndex = props.setDispIndex;
  const index = props.index;
  const saleImage = props.saleImage;
  const movieTitle = props.movieTitle;

  const isPc = useContext(cmnContext).isPc;
  const grayColor = useContext(SaleListContext).grayColor;

  const [itemBackClr, setItemBackClr] = useState<string>(grayColor);
  const [itemFntClr, setItemFntClr] = useState<string>('black');


  useEffect(() => {
    if(available) {
      if(index == dispIndex) {
        setItemBackClr('black');
        setItemFntClr('white');
      } else {
        setItemBackClr(grayColor);
        setItemFntClr('black');
      }
    } else {
      setItemBackClr(grayColor);
      setItemFntClr('black');
    }
  }, [available, dispIndex])


  const onPress = () => {
    if(available) {
      setDispIndex(index);
    }
  }


  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: isPc? '3% 1%':'5% 3%',
        borderTopColor: '#fff',
        borderTopStyle: 'solid',
        borderTopWidth: '2px',
        backgroundColor: itemBackClr,
      }}
      onClick={onPress}
    >

      <span style={{
        color: itemFntClr,
        fontSize: isPc? '120%': '100%',
        fontWeight: 'bold',
      }}>{index+1}</span>

      <img
        src={`/images/sale/${saleImage}`}
        style={{
          display: 'block',
          width: isPc? '30%':'40%',
          objectFit: 'contain',
          objectPosition: 'center',
          margin: '0px 10px',
        }}
        alt={movieTitle}
      />

      <span style={{
        color: itemFntClr,
        fontWeight: 'bold',
      }}>{movieTitle}</span>

    </div>
  );
}